import {useState} from 'react';

const useModalSwipeClose = (onClose, shouldCloseOnSwipeDown = true) => {
    const [touchYStart, setTouchYStart] = useState(0);

    const onTouchStart = (e) => {
        setTouchYStart(e.changedTouches[0].pageY);
    };

    const onTouchMove = (e) => {
        const touchYEnd = e.changedTouches[0].pageY;

        const delta = touchYEnd - touchYStart;
        const SWIPE_DELTA_TO_START_CLOSING = 30;

        if (delta >= SWIPE_DELTA_TO_START_CLOSING && onClose && shouldCloseOnSwipeDown) {
            onClose?.();
        }
    };

    return {onTouchStart, onTouchMove};
};

export default useModalSwipeClose;
